import { createStyles, IconButton, List, makeStyles } from "@material-ui/core";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { Location } from "history";
import * as React from "react";

import { Divider, MobileTitleBar, RelodeTheme, useRouter } from "../";
import { MenuIcon, TimesIcon } from "../../assets/icons";
import { LogoWithTextBeside } from "../../assets/logos";
import { AppMenuProps, AppMenuPropsExtended } from "./appMenuProps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                position: "fixed",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: theme.relode.sizes.mobileAppBarHeight,
                borderBottom: `1px solid ${theme.palette.divider}`,
                backgroundColor: "white",
                padding: 8,
                width: "100%",
                zIndex: 1000,
            },
            logo: {
                flexGrow: 1,
                display: "flex",
                alignItems: "center",
            },
            drawerHeader: {
                display: "flex",
                alignItems: "center",
                padding: theme.spacing(0, 1),
                // necessary for content to be below app bar
                ...theme.mixins.toolbar,
                justifyContent: "flex-end",
            },
        }),
    { name: "AppMobileMenu" }
);

export const AppMenuMobile = (
    props: AppMenuProps &
        AppMenuPropsExtended & { isMenuOpen: boolean; toggleMenu: () => void }
) => {
    const classes = useStyles({});
    const { isMenuOpen, toggleMenu, menuItems, systemItems } = props;
    const { location } = useRouter();
    const previousLocation = React.useRef<Location<any>>(undefined);

    React.useEffect(() => {
        if (!previousLocation.current) {
            previousLocation.current = location;
        } else {
            if (
                location.pathname !== previousLocation.current.pathname &&
                isMenuOpen
            ) {
                previousLocation.current = undefined;
                toggleMenu();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, isMenuOpen]);

    const showMenu =
        (menuItems?.length ?? 0) > 0 || (systemItems?.length ?? 0) > 0;

    return (
        <>
            <MobileTitleBar>
                <div className={classes.logo}>
                    <LogoWithTextBeside
                        height={19}
                        width={null}
                        textColor="#33006e"
                    />
                </div>
                {showMenu ? (
                    <IconButton edge="end" color="primary" onClick={toggleMenu}>
                        <MenuIcon height={19} width={19} />
                    </IconButton>
                ) : null}
            </MobileTitleBar>
            {showMenu ? (
                <SwipeableDrawer
                    anchor="top"
                    open={isMenuOpen}
                    onClose={toggleMenu}
                    onOpen={toggleMenu}
                >
                    <div className={classes.drawerHeader}>
                        <div className={classes.logo}>
                            <LogoWithTextBeside
                                height={19}
                                textColor="#33006e"
                            />
                        </div>
                        <IconButton onClick={toggleMenu} color="primary">
                            <TimesIcon height={19} width={19} />
                        </IconButton>
                    </div>
                    <List>{menuItems}</List>
                    {systemItems && systemItems.length > 0 ? (
                        <>
                            <Divider />
                            <List>{systemItems}</List>
                        </>
                    ) : null}
                </SwipeableDrawer>
            ) : null}
        </>
    );
};
